import * as React from "react";
import type { SVGProps } from "react";
const SvgTerraceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <g clipPath="url(#terrace-icon_svg__a)">
      <path
        fill="#858585"
        d="M27.563 1.313V.438H14a.437.437 0 0 0-.437.437v3.5c0 .242.195.438.437.438h.438v21.875h-14v.875h27.125v-.875h-5.25V24.5h5.25v-.875h-8.75v-.875h8.75v-.875h-9.188a.437.437 0 0 0-.437.438v1.75c0 .241.195.437.437.437h1.313v2.188h-2.625V4.813h10.5v-.875H14.438V1.313zm-7 23.187h.875v2.188h-.875zM16.188 4.813v21.875h-.875V4.813z"
      />
    </g>
    <defs>
      <clipPath id="terrace-icon_svg__a">
        <path fill="#fff" d="M0 0h28v28H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTerraceIcon;
